import {
    CopyBriefComponent,
    CopyBriefMutation,
    CopyBriefMutationVariables,
} from '@99designs/apps/spa/pages/create/mutations/CopyBrief.generated';
import React from 'react';
import { FetchResult, MutationResult } from '@apollo/client';

interface Props {
    children: (
        copyBrief: (
            variables: CopyBriefMutationVariables
        ) => Promise<void | FetchResult<CopyBriefMutation>>,
        result: MutationResult
    ) => React.ReactElement;
}

class CopyBrief extends React.Component<Props> {
    render() {
        const { children } = this.props;
        return (
            <CopyBriefComponent>
                {(mutation, result) => {
                    return children(
                        (variables) =>
                            mutation({ variables }).catch((e) => {
                                this.setState(() => {
                                    throw e;
                                });
                            }),
                        result
                    );
                }}
            </CopyBriefComponent>
        );
    }
}

export default CopyBrief;
